import React, { useState, ChangeEvent } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import act from '@flux/actions/actView';
import { Button, Grid, TextInput } from '@ts/storybook';

interface QuickFindProps extends WithTranslation {
  modelName: string;
  pathToStore: string;
  initLike?: string;
}

const QuickFind: React.FC<QuickFindProps> = ({ modelName, pathToStore, initLike = '', t }) => {
  const [like, setLike] = useState(initLike);

  const handleQuickFindChange = (value: string | number | null) => {
    setLike(value ? value.toString() : '');
  };

  const handleQuickFindButton = () => {
    act.fetch({
      url: '/api/quickfind',
      dataPath: pathToStore,
      data: {
        limit: 200,
        modelName,
        findAndCount: true,
        like,
      },
    });
  };

  return (
    <Grid container size={{ xs: 'auto' }}>
      <Grid>
        <TextInput placeholder="Find by id/name" value={like} onChangeValue={handleQuickFindChange} />
      </Grid>
      <Grid>
        <Button key="quickFind" label="Find" onClick={handleQuickFindButton} disabled={isEmpty(like)} />
      </Grid>
    </Grid>
  );
};

export default withTranslation()(QuickFind);
